import React from 'react'
import {Flex, useStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import FiltersButton from '../../../pages/product-list/partials/filters-button'
import {useLocation} from 'react-router-dom'
import {getSelectedFiltersFromUrl} from '../utils/recipe-search-params-utils'

import RecipeMenuButton from './recipe-menu-button'

const RecipeFiltersMenu = ({filters, onOpen, isMobile}) => {
    const location = useLocation()
    const selectedFilters = getSelectedFiltersFromUrl(location, filters)
    const styles = useStyleConfig('RecipeList')

    return (
        <Flex {...styles?.filterMenuInnerContainer}>
            {isMobile ? (
                <FiltersButton buttonClick={onOpen} />
            ) : (
                <>
                    {filters?.length > 0 &&
                        filters?.map((filter, idx) => (
                            <RecipeMenuButton
                                key={`recipe-inline-filter-${idx}`}
                                filter={filter}
                                selectedFilters={selectedFilters}
                            />
                        ))}
                </>
            )}
        </Flex>
    )
}

RecipeFiltersMenu.propTypes = {
    filters: PropTypes.array,
    setSelectedFilters: PropTypes.func,
    selectedFilters: PropTypes.object,
    onOpen: PropTypes.func,
    isMobile: PropTypes.bool,
}

export default RecipeFiltersMenu
